import * as React from 'react';
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
const IconSatisfaction = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  role: "img"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M17.1426 8.58984L10.0052 15.447L6.85686 12.4223",
  stroke: "#00111A",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.8034 2.69579L15.8454 2.71636L15.8897 2.73154L19.8949 4.10512L21.2685 8.11032L21.2836 8.15459L21.3042 8.19663L23.165 12L21.3042 15.8034L21.2836 15.8454L21.2685 15.8897L19.8949 19.8949L15.8897 21.2685L15.8454 21.2836L15.8034 21.3042L12 23.165L8.19663 21.3042L8.15459 21.2836L8.11032 21.2685L4.10512 19.8949L2.73154 15.8897L2.71636 15.8454L2.69579 15.8034L0.834954 12L2.69579 8.19663L2.71636 8.15459L2.73154 8.11032L4.10512 4.10512L8.11032 2.73154L8.15459 2.71636L8.19663 2.69579L12 0.834954L15.8034 2.69579Z",
  stroke: "#00111A",
  strokeWidth: 1.5
}));
export { IconSatisfaction };